const config = {
  apiBaseUrl: process.env.REACT_APP_API_URL || '',
  mapApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  stripeApiKey: process.env.REACT_APP_STRIPE_PUBLIC_KEY_ORIGINAL,
  astripeTestApiKey: process.env.REACT_APP_STRIPE_PUBLIC_KEY,
};

export default config;
